// Action types
export const PROPERTY_SHOW_LOADING_ACTION_RESET = 'PROPERTY_SHOW_LOADING_ACTION_RESET';
export const PROPERTY_SHOW_LOADING_ACTION_START_REQUEST = 'PROPERTY_SHOW_LOADING_ACTION_START_REQUEST';
export const PROPERTY_SHOW_LOADING_ACTION_SET_PROPERTY_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_SET_PROPERTY_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_SET_METERS_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_SET_METERS_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_METERS_DISPLAYED = 'PROPERTY_SHOW_LOADING_ACTION_METERS_DISPLAYED';
export const PROPERTY_SHOW_LOADING_ACTION_SET_RULES_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_SET_RULES_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_RULES_DISPLAYED = 'PROPERTY_SHOW_LOADING_ACTION_RULES_DISPLAYED';
export const PROPERTY_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS = 'PROPERTY_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS';
export const PROPERTY_SHOW_LOADING_ACTION_MARK_FULLY_LOADED = 'PROPERTY_SHOW_LOADING_ACTION_MARK_FULLY_LOADED';
export const PROPERTY_SHOW_LOADING_ACTION_DATA_PREPARED = 'PROPERTY_SHOW_LOADING_ACTION_DATA_PREPARED';
export const PROPERTY_SHOW_LOADING_ACTION_RENDERING_DISPLAYED = 'PROPERTY_SHOW_LOADING_ACTION_RENDERING_DISPLAYED';
export const PROPERTY_SHOW_LOADING_ACTION_HIDE_OVERLAY = 'PROPERTY_SHOW_LOADING_ACTION_HIDE_OVERLAY';
export const PROPERTY_SHOW_LOADING_ACTION_SET_ERROR = 'PROPERTY_SHOW_LOADING_ACTION_SET_ERROR';
export const PROPERTY_SHOW_LOADING_ACTION_CANCEL_REQUEST = 'PROPERTY_SHOW_LOADING_ACTION_CANCEL_REQUEST';

export const PropertyShowLoadingActions = Object.freeze({
  RESET: PROPERTY_SHOW_LOADING_ACTION_RESET,
  START_REQUEST: PROPERTY_SHOW_LOADING_ACTION_START_REQUEST,
  SET_PROPERTY_LOADED: PROPERTY_SHOW_LOADING_ACTION_SET_PROPERTY_LOADED,
  SET_METERS_LOADED: PROPERTY_SHOW_LOADING_ACTION_SET_METERS_LOADED,
  METERS_DISPLAYED: PROPERTY_SHOW_LOADING_ACTION_METERS_DISPLAYED,
  SET_RULES_LOADED: PROPERTY_SHOW_LOADING_ACTION_SET_RULES_LOADED,
  RULES_DISPLAYED: PROPERTY_SHOW_LOADING_ACTION_RULES_DISPLAYED,
  SET_CONSUMED_DATA_LOADED: PROPERTY_SHOW_LOADING_ACTION_SET_CONSUMED_DATA_LOADED,
  SET_GENERATED_DATA_LOADED: PROPERTY_SHOW_LOADING_ACTION_SET_GENERATED_DATA_LOADED,
  SET_TRADE_SUMMARY_PROGRESS: PROPERTY_SHOW_LOADING_ACTION_SET_TRADE_SUMMARY_PROGRESS,
  MARK_FULLY_LOADED: PROPERTY_SHOW_LOADING_ACTION_MARK_FULLY_LOADED,
  DATA_PREPARED: PROPERTY_SHOW_LOADING_ACTION_DATA_PREPARED,
  RENDERING_DISPLAYED: PROPERTY_SHOW_LOADING_ACTION_RENDERING_DISPLAYED,
  HIDE_OVERLAY: PROPERTY_SHOW_LOADING_ACTION_HIDE_OVERLAY,
  SET_ERROR: PROPERTY_SHOW_LOADING_ACTION_SET_ERROR,
  CANCEL_REQUEST: PROPERTY_SHOW_LOADING_ACTION_CANCEL_REQUEST,
});

// Loading states
export const PROPERTY_SHOW_LOADING_STATE_IDLE = 'PROPERTY_SHOW_LOADING_STATE_IDLE';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_PROPERTY = 'PROPERTY_SHOW_LOADING_STATE_LOADING_PROPERTY';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_METERS = 'PROPERTY_SHOW_LOADING_STATE_LOADING_METERS';
export const PROPERTY_SHOW_LOADING_STATE_METERS_LOADED = 'PROPERTY_SHOW_LOADING_STATE_METERS_LOADED';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_RULES = 'PROPERTY_SHOW_LOADING_STATE_LOADING_RULES';
export const PROPERTY_SHOW_LOADING_STATE_RULES_LOADED = 'PROPERTY_SHOW_LOADING_STATE_RULES_LOADED';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_CONSUMED = 'PROPERTY_SHOW_LOADING_STATE_LOADING_CONSUMED';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_GENERATED = 'PROPERTY_SHOW_LOADING_STATE_LOADING_GENERATED';
export const PROPERTY_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY = 'PROPERTY_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY';
export const PROPERTY_SHOW_LOADING_STATE_PREPARING_DATA = 'PROPERTY_SHOW_LOADING_STATE_PREPARING_DATA';
export const PROPERTY_SHOW_LOADING_STATE_RENDERING = 'PROPERTY_SHOW_LOADING_STATE_RENDERING';
export const PROPERTY_SHOW_LOADING_STATE_COMPLETE = 'PROPERTY_SHOW_LOADING_STATE_COMPLETE';
export const PROPERTY_SHOW_LOADING_STATE_ERROR = 'PROPERTY_SHOW_LOADING_STATE_ERROR';
export const PROPERTY_SHOW_LOADING_STATE_CANCELLED = 'PROPERTY_SHOW_LOADING_STATE_CANCELLED';

export const PropertyShowLoadingStates = Object.freeze({
  IDLE: PROPERTY_SHOW_LOADING_STATE_IDLE,
  LOADING_PROPERTY: PROPERTY_SHOW_LOADING_STATE_LOADING_PROPERTY,
  LOADING_METERS: PROPERTY_SHOW_LOADING_STATE_LOADING_METERS,
  METERS_LOADED: PROPERTY_SHOW_LOADING_STATE_METERS_LOADED,
  LOADING_RULES: PROPERTY_SHOW_LOADING_STATE_LOADING_RULES,
  RULES_LOADED: PROPERTY_SHOW_LOADING_STATE_RULES_LOADED,
  LOADING_CONSUMED: PROPERTY_SHOW_LOADING_STATE_LOADING_CONSUMED,
  LOADING_GENERATED: PROPERTY_SHOW_LOADING_STATE_LOADING_GENERATED,
  LOADING_TRADE_SUMMARY: PROPERTY_SHOW_LOADING_STATE_LOADING_TRADE_SUMMARY,
  PREPARING_DATA: PROPERTY_SHOW_LOADING_STATE_PREPARING_DATA,
  RENDERING: PROPERTY_SHOW_LOADING_STATE_RENDERING,
  COMPLETE: PROPERTY_SHOW_LOADING_STATE_COMPLETE,
  ERROR: PROPERTY_SHOW_LOADING_STATE_ERROR,
  CANCELLED: PROPERTY_SHOW_LOADING_STATE_CANCELLED,
});

/**
 * Message keys used by the loading overlay.
 */
export const LoadingMessageKeys = Object.freeze({
  NONE: 'none',
  LOADING_PROPERTY: 'loading_property',
  PROPERTY_LOADED: 'property_loaded',
  METERS_LOADED: 'meters_loaded',
  RULES_LOADED: 'rules_loaded',
  CONSUMED_DATA_LOADED: 'consumed_data_loaded',
  TRADE_SUMMARY_PROGRESS: 'trade_summary_progress',
  PREPARING_DATA: 'preparing_data',
  RENDERING: 'rendering',
  COMPLETE: 'complete',
});

/**
 * Stage keys used to identify individual loading stages for parallel tracking.
 * These are used in the activeStages and completedStages arrays.
 */
export const StageKeys = Object.freeze({
  IDLE: 'IDLE',
  PROPERTY: 'PROPERTY',
  METERS: 'METERS',
  RULES: 'RULES',
  CONSUMED_DATA: 'CONSUMED_DATA',
  GENERATED_DATA: 'GENERATED_DATA',
  TRADE_SUMMARY: 'TRADE_SUMMARY',
  DATA_PREPARED: 'DATA_PREPARED',
  DATA_RENDERED: 'DATA_RENDERED',
  ERROR: 'ERROR',
});

/**
 * Progress weight for each stage key. Weights represent each stage's share
 * of total work and sum to 100. Used by calculateProgress to compute dynamic
 * progress from completedStages and activeStages arrays.
 */
export const STAGE_PROGRESS = {
  [StageKeys.IDLE]: 0, // Idle
  [StageKeys.PROPERTY]: 5, // Stage 1: Loading property
  [StageKeys.METERS]: 20, // Stage 2: Loading meters
  [StageKeys.RULES]: 10, // Stage 3: Loading trade rules
  [StageKeys.CONSUMED_DATA]: 10, // Stage 4: Loading consumed meter data
  [StageKeys.GENERATED_DATA]: 10, // Stage 5: Loading generated meter data
  [StageKeys.TRADE_SUMMARY]: 20, // Stage 6: Loading trade summary
  [StageKeys.DATA_PREPARED]: 10, // Stage 7: Preparing data
  [StageKeys.DATA_RENDERED]: 15, // Stage 8: Rendering data
  [StageKeys.ERROR]: 0, // Error
};

export const defaultInitialState = () => ({
  state: PropertyShowLoadingStates.IDLE,
  activeStages: [],
  completedStages: [],
  metadata: {
    metersCount: 0,
    rulesCount: 0,
    batchesLoaded: 0,
    batchesTotal: 0,
    error: null,
  },
  overlay: {
    progressBarValue: 0,
    messageKey: LoadingMessageKeys.NONE,
  },
});
